import type { PickerItem } from './classificationPicker';
export type { PickerItem } from './classificationPicker';

/** Existing rows win, including user-entered property values and their order. */
export function mergePickerItems(existing: PickerItem[], added: PickerItem[]): PickerItem[] {
  const seen = new Set<string>();
  return [...existing, ...added].filter((item) => {
    const id = String(item.id);
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}

/** The outer ID is classified; the nested detail ID must never replace it. */
export function normalizeClassifiedItems(
  items: PickerItem[],
  detailKey: 'property_definition' | 'technical_report_item'
): PickerItem[] {
  return items.map((item) => {
    const detail = item[detailKey] as { title?: string; description?: string } | undefined;
    return {
      ...item,
      title: item.title ?? detail?.title,
      description: item.description ?? detail?.description,
    };
  });
}

export async function loadTechnicalReportSets(
  sets: PickerItem[],
  get: (url: string) => Promise<{ data: { technical_report_item_set: PickerItem[] } }>
): Promise<PickerItem[]> {
  let items: PickerItem[] = [];
  for (const set of sets) {
    if (!set.id_detail) throw new Error('Chybí identifikátor detailu sady.');
    const { data } = await get(`/api/v1/set-technical-report-item/${set.id_detail}/last-version/`);
    items = mergePickerItems(
      items,
      normalizeClassifiedItems(data.technical_report_item_set, 'technical_report_item')
    );
  }
  return items;
}
